import $ from "jquery"
import "slick-carousel-latest"

// blog slider
$('.people-slider').slick({
    infinite: true,
    slidesToShow:4,
    slidesToScroll: 1,
    arrow: true,
    nextArrow:"<span class='slick-arrow slick-next d-flex justify-content-center align-items-center '><i class='fa-solid fa-arrow-right'></i></span>",
    prevArrow:"<span class='slick-arrow slick-prev d-flex justify-content-center align-items-center '><i class='fa-solid fa-arrow-left'></i></span>",
    responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3
          }
        },
        {
            breakpoint: 936,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 625,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});